<form [formGroup]="form">
  <mat-accordion>
    <mat-expansion-panel [expanded]="expandedFilter" (opened)="expandedFilter = true"
      (closed)="expandedFilter = false">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'protocolList.filter.title' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div fxLayout="row" fxLayout.xs="column" class="flexwrap">

        <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'protocolList.filter.documentCode.label' | translate }}</mat-label>
            <input matInput
              formControlName="documentCode" [(ngModel)]="filter.documentCode">
          </mat-form-field>
        </div>
        <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
          <mat-form-field class="datepicker">
            <mat-label>{{ 'protocolList.filter.regFcEnd.label' | translate }}</mat-label>
            <input matInput [matDatepicker]="regFcEndPicker" formControlName="regFcEnd"
              [ngModel]="filter.realizationDate" (blur)="saveDate('regFcEnd', $event)"
              (dateChange)="saveDate('regFcEnd', $event)">
            <mat-datepicker-toggle matSuffix [for]="regFcEndPicker"></mat-datepicker-toggle>
            <mat-datepicker #regFcEndPicker >
            </mat-datepicker>
          </mat-form-field>
        </div>
        <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
          <mat-form-field class="datepicker">
            <mat-label>{{ 'protocolList.filter.regFcEnd.label' | translate }}</mat-label>
            <input matInput [matDatepicker]="regFcEndPicker" formControlName="regFcEnd"
              [ngModel]="filter.nextInterventionDate" (blur)="saveDate('regFcEnd', $event)"
              (dateChange)="saveDate('regFcEnd', $event)">
            <mat-datepicker-toggle matSuffix [for]="regFcEndPicker"></mat-datepicker-toggle>
            <mat-datepicker #regFcEndPicker >
            </mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <mat-accordion>
        <mat-expansion-panel expanded="false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ 'protocolList.filter.advanced.title' | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div fxLayout="row" fxLayout.xs="column" class="flexwrap">

            <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'protocolList.filter.area.label' | translate }}</mat-label>
                <input matInput
                  formControlName="areaName" [(ngModel)]="filter.areaName">
              </mat-form-field>
            </div>

            <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'protocolList.filter.equipment.label' | translate }}</mat-label>
                <mat-select formControlName="equipment" [(ngModel)]="filter.equipment">
                  @for (item of equipmentTypes; track item) {
                    <mat-option [value]="item.id">
                      {{ 'equipmentType.' + item.translation | translate }}
                    </mat-option>
                  }
                </mat-select>
                <mat-error>
                  {{ 'protocolEdit.dialog.equipment.type.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'protocolList.filter.equipmentSerialNum.label' | translate }}</mat-label>
                <input matInput formControlName="equipmentSerialNum"
                  [(ngModel)]="filter.equipmentSerialNum">
              </mat-form-field>
            </div>
            <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'protocolList.filter.identificative.label' | translate }}</mat-label>
                <input matInput
                  formControlName="identificative" [(ngModel)]="filter.identificative">
              </mat-form-field>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
        <button mat-raised-button (click)="doFilter()" color="primary">{{ 'button.filter' | translate
        }}</button>
        <button mat-button (click)="cleanFilter()">{{ 'button.clean' | translate }}</button>
      </div>

    </mat-expansion-panel>
  </mat-accordion>
</form>